import { ToggleExpandButton } from '../../../../../components';
import React, { useRef } from 'react';
import { InlineDiv, RelativeDiv, AbsoluteDiv } from './HeaderDropdown.styles';
import HeaderDropdownMenu from './HeaderDropdownMenu';
import { useSelectUserContext } from '../../../../../selectors';

interface HeaderDropdownButtonProps {
	menuOpen: boolean;
	list: JSX.Element[];
	anchorOrigin: 'left' | 'right' | 'center';
	setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
	cy: string;
}

export default function HeaderDropdownButton({
	menuOpen,
	list,
	setMenuOpen,
	anchorOrigin,
	cy,
}: HeaderDropdownButtonProps): JSX.Element | null {
	const menuAnchorRef = useRef<HTMLDivElement>(null);
	const openMenu = () => setMenuOpen(true);
	const closeMenu = () => setMenuOpen(false);

	const { loading: contextLoading } = useSelectUserContext();
	if (!list?.length) return null;

	return (
		<InlineDiv>
			{!contextLoading && (
				<ToggleExpandButton
					menuOpen={menuOpen}
					onClick={openMenu}
					cy={cy}
				/>
			)}
			<RelativeDiv>
				<AbsoluteDiv ref={menuAnchorRef} />
			</RelativeDiv>
			<HeaderDropdownMenu
				anchorOrigin={anchorOrigin}
				closeMenu={closeMenu}
				menuAnchorRef={menuAnchorRef}
				menuOpen={menuOpen}>
				{list}
			</HeaderDropdownMenu>
		</InlineDiv>
	);
}
